import { forwardRef, RefAttributes } from "react";
import { transitionClassName } from "./commonClassNames";

export type InputCheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, "className" | "type"> &
  RefAttributes<HTMLInputElement> & {
    className?: string;
    small?: boolean;
  };

export const InputCheckbox: React.FC<InputCheckboxProps> = forwardRef(({ id, className, small, ...props }, ref) => {
  const combinedClassName = [
    small === true ? "h-4 w-4" : "h-5 w-5",
    "appearance-none rounded border border-neutral-400 checked:bg-primary-300 cursor-pointer hover:border-primary-500 checked:border-primary-500",
    transitionClassName({ colors: true }),
    "focus:outline-none focus:ring focus:border-blue-500",
    className ?? "",
  ].join(" ");

  return <input className={combinedClassName} type="checkbox" id={id} {...props} ref={ref} />;
});
